export const VISUAL_DEFAULTS = {
    width: 800,
    height: 600,
    horizonHeight: 80,
    topPadding: 24,
    minDiameterPx: 18,
    maxDiameterPx: 180,
    minPositiveGapPx: 6,
};

export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export function getVisualAsteroids(asteroids, options = {}) {
    const settings = { ...VISUAL_DEFAULTS, ...options };
    const horizonY = settings.height - settings.horizonHeight;
    const validDiameters = asteroids
        .map(a => a.estDimAvgM)
        .filter(value => Number.isFinite(value) && value > 0);
    const minDiameterM = validDiameters.length ? Math.min(...validDiameters) : 0;
    const maxDiameterM = validDiameters.length ? Math.max(...validDiameters) : 0;
    const maxVisualDiameter = Math.min(
        settings.maxDiameterPx,
        settings.width * 0.24,
        (horizonY - settings.topPadding) * 0.45
    );
    const singleDiameterPx = (settings.minDiameterPx + maxVisualDiameter) / 2;

    const scaleDiameter = diameterM => {
        if (!Number.isFinite(diameterM) || diameterM <= 0) {
            return settings.minDiameterPx;
        }

        if (maxDiameterM <= minDiameterM) {
            return singleDiameterPx;
        }

        const ratio = (diameterM - minDiameterM) / (maxDiameterM - minDiameterM);
        return settings.minDiameterPx + clamp(ratio, 0, 1) * (maxVisualDiameter - settings.minDiameterPx);
    };

    const maxDist = asteroids.length
        ? Math.max(...asteroids.map(a => Number.isFinite(a.missDistKM) ? Math.max(0, a.missDistKM) : 0))
        : 0;
    const maxGap = Math.max(0, horizonY - settings.topPadding - maxVisualDiameter);
    const positiveGapFloor = Math.min(settings.minPositiveGapPx, maxGap);

    return asteroids.map(a => {
        const safeDistance = Number.isFinite(a.missDistKM) ? Math.max(0, a.missDistKM) : 0;
        const distanceRatio = maxDist > 0 ? clamp(safeDistance / maxDist, 0, 1) : 0;
        const gapFromHorizon = safeDistance > 0
            ? positiveGapFloor + distanceRatio * Math.max(0, maxGap - positiveGapFloor)
            : 0;
        const visualDiameter = scaleDiameter(a.estDimAvgM);

        return {
            ...a,
            visualDiameter,
            visualRadius: visualDiameter / 2,
            distanceRatio,
            gapFromHorizon,
            bottomY: horizonY - gapFromHorizon,
            centerY: horizonY - gapFromHorizon - visualDiameter / 2,
        };
    });
}

export function sortLargestFirst(asteroids) {
    return [...asteroids].sort((a, b) => {
        const sizeDelta = b.estDimAvgM - a.estDimAvgM;
        if (sizeDelta !== 0) return sizeDelta;
        return b.missDistKM - a.missDistKM;
    });
}

export function sortClosestFirst(asteroids) {
    return [...asteroids].sort((a, b) => {
        const distanceDelta = a.missDistKM - b.missDistKM;
        if (distanceDelta !== 0) return distanceDelta;
        return b.estDimAvgM - a.estDimAvgM;
    });
}
